import type { Step } from '@/components/wizard/Step';

import type { MongoAtlasPrivateLinkWizardState } from './mongoAtlasPrivateLinkWizardState';
import { CompleteAtlasPrivateLink } from './steps/completeAtlasPrivateLink';
import { SetupAtlasPrivateLink } from './steps/setupAtlasPrivateLink';

const completeStep: Step<MongoAtlasPrivateLinkWizardState> = {
  id: 'complete_atlas_private_link',
  Component: CompleteAtlasPrivateLink,
  nonReturnable: true,
};

export const mongoAtlasPrivateLinkFlow: Step<MongoAtlasPrivateLinkWizardState> =
  {
    id: 'setup_atlas_private_link',
    Component: SetupAtlasPrivateLink,
    nonReturnable: false,
    next: [completeStep],
  };
